module.exports = __webpack_public_path__ + "media/dashboard/assets/images/image-off-f0c1fbc186daf0178e8fbcfc134d2289.png";